<template>
  <div class="mx-2">
    <v-subheader class="title"
      >{{ $t("modules.home.overview") }}:
      {{ $store.state.login.user.environment_name }}</v-subheader
    >
    <v-row>
      <v-col md="6">
        <v-card class="mb-3">
          <v-subheader class="title">{{
            $t("modules.home.status")
          }}</v-subheader>
          <div
            v-if="isPermitted(PermissionEnum.DEVICES.VIEW)"
            class="pb-4 px-2"
          >
            <devices-status
              :status="status"
              :totalUpload="totalUpload"
              :totalDownload="totalDownload"
              id="devices__status"
            ></devices-status>
          </div>
          <div v-else class="pa-2">
            <v-alert color="red" text class="ma-2 mb-4">
              {{ $t("modules.home.notPermitted") }}
            </v-alert>
          </div>
        </v-card>
        <v-card>
          <v-subheader class="title">
            {{ $t("modules.home.devices") }}
          </v-subheader>
          <div v-if="isPermitted(PermissionEnum.DEVICES.VIEW)">
            <devices-table
              :headers="devicesTable.headers"
              :has-selection="true"
              css-class="mx-0"
              id="devices-overview-table"
              :isHomeFilterShow="true"
            ></devices-table>
          </div>
          <div v-else class="pa-2">
            <v-alert
              color="red"
              text
              class="ma-2 mb-4"
              id="devices__table-error"
            >
              {{ $t("modules.home.notPermitted") }}
            </v-alert>
          </div>
        </v-card>
      </v-col>
      <v-col md="6">
        <div v-if="isPermitted(PermissionEnum.LOGS.VIEW)">
          <div>
            <v-subheader class="title pl-0">
              {{ $t("modules.home.lastAuditEvents") }}
            </v-subheader>
            <audit-events></audit-events>
          </div>
          <div class="pb-3">
            <v-subheader class="title pl-0">
              {{ $t("modules.home.lastSystemEvents") }}
            </v-subheader>
            <system-events></system-events>
          </div>
        </div>
        <div v-else class="pa-2">
          <v-alert
            color="red"
            text
            class="ma-2 mb-4"
            id="device__details-error"
          >
            {{ $t("modules.home.notPermitted") }}
          </v-alert>
        </div>
        <div v-if="isPermitted(PermissionEnum.DEVICES.VIEW)">
          <v-card>
            <device-location
              :device-id="details && details.id ? details.id : ''"
              :details="halo_data_links_availability"
              :devices="devices"
              id="device__location"
            ></device-location>
            <device-details
              :details="details"
              :permissions="loggedInUserPermissions"
              :environment-manager="environment_manager"
              id="device__details"
              :key="key"
            ></device-details>
          </v-card>
        </div>
        <div v-else class="pa-2">
          <v-alert
            color="red"
            text
            class="ma-2 mb-4"
            id="device__details-error"
          >
            {{ $t("modules.home.notPermitted") }}
          </v-alert>
        </div>
      </v-col>
    </v-row>
    <status-message></status-message>
  </div>
</template>

<script>
import DevicesTable from "@/modules/devices/components/devices-table";
import DeviceDetails from "./components/device-details";
import StatusMessage from "@/components/status-message";
import { handleError } from "@/utils/error";
import DevicesStatus from "./components/devices-status";
import DeviceLocation from "./components/device-location";
import AuditEvents from "./components/audit-events.vue";
import SystemEvents from "./components/system-events.vue";
import { devicesMixins } from "@/modules/devices/mixins";
import { sleeper, periodicCall, getDeepCopy } from "@/utils";
import { permissionMixin } from "@/mixins/permissions.js";
import constants from "@/utils/constants";

export default {
  name: "HomePage",
  components: {
    DeviceLocation,
    DevicesStatus,
    StatusMessage,
    DeviceDetails,
    DevicesTable,
    AuditEvents,
    SystemEvents
  },
  mixins: [devicesMixins, permissionMixin],
  data() {
    return {
      key: Math.random(),
      devicesTable: {
        headers: [
          {
            text: this.$t("modules.devices.name"),
            align: "left",
            value: "name"
          },
          {
            text: this.$t("modules.devices.pairing_id"),
            align: "left d-none",
            value: "pairing_id"
          },
          {
            text: this.$t("modules.devices.availability"),
            align: "center",
            value: "availability"
          },
          {
            text: this.$t("modules.devices.links"),
            align: "center",
            value: "links"
          },
          {
            text: this.$t("modules.devices.gnssLock"),
            align: "center",
            value: "latest_location"
          },
          {
            text: this.$t("modules.devices.membership"),
            align: "left",
            value: "membership"
          }
        ]
      },
      devicesStateIntervalId: null
    };
  },

  computed: {
    applicationRules() {
      return this.$store.state.dataPath.applicationRules;
    },
    selected: {
      get() {
        return this.$store.state.devices.selected;
      },
      set(val) {
        this.$store.commit("devices/updateSelected", val);
      }
    },
    halo_system_report() {
      return this.$store.state.devices.halo_system_report;
    },

    details() {
      if (this.selected.length === 0 || this.devices.length === 0) {
        return null;
      }
      let selected = this.selected[0];
      let details = getDeepCopy(
        this.devices.find(item => item.id === selected.id)
      );

      // Extract application rules information
      let applicationRules = details.application_rules;
      details.rules = [];
      applicationRules.map(item => {
        let applicationRule = this.applicationRules.find(
          data => data.id === item
        );
        if (applicationRule) {
          let hostLists = Object.keys(applicationRule.hosts_list);
          if (hostLists.indexOf(details.id) !== -1) {
            applicationRule.type = "host";
          } else if (applicationRule.hubs_list.indexOf(details.id) !== -1) {
            applicationRule.type = "hub";
          } else {
            applicationRule.type = "";
          }
          details.rules.push(applicationRule);
        }
      });
      return details;
    }
  },

  mounted() {
    this.$store.commit("devices/updateSearch", "");
  },
  created() {
    if (this.isPermitted(this.PermissionEnum.DEVICES.VIEW))
      this.devicesStateIntervalId = periodicCall(
        this.fetchDevicesState,
        constants.REQUEST_INTERVAL_IN_MILLISECONDS
      );
  },
  beforeDestroy() {
    if (this.devicesStateIntervalId) clearInterval(this.devicesStateIntervalId);
  },

  watch: {
    devices: {
      deep: true,
      handler(val) {
        if (this.selected.length > 0) {
          setTimeout(() => {
            let device = val.find(item => item.id === this.selected[0].id);
            this.details.main_app_status = device.main_app_status;
            this.details.latest_location = device.latest_location || null;
            if (this.details.latest_location) {
              this.details.latest_location.status = this.checkLocationStatus(
                this.details.latest_location
              );
            }
            this.details.availability = device.availability || "-";
            this.key = Math.random();
          }, 1);
        }
      }
    },

    selected(newValue, oldValue) {
      // condition to prevent double api call on select
      if (oldValue.length > 0 && newValue[0].id !== oldValue[0].id) {
        this.$store
          .dispatch("devices/fetchDevicesStatus", {
            devices: [this.selected[0].id]
          })
          .then(response => {
            let data = response.data;
            this.$store.commit("devices/loadDevicesStatus", data);
            // info
            let status = data[this.selected[0].id];
            if (status) {
              this.details.halo_data_links_info = status.halo_data_links_info;
              this.details.halo_system_report = status.halo_system_report;
            } else {
              this.details.halo_data_links_info = null;
              this.details.halo_system_report = null;
            }

            this.key = Math.random(); // force update component for reactivity
          })
          .catch(error => handleError(error));
      }
      if (oldValue.length === 0) {
        this.fetchDevicesStatus();
      }
    }
  },

  methods: {
    sleeper: sleeper,
    fetchDevicesStatus() {
      return this.$store
        .dispatch("devices/fetchDevicesStatus", {
          devices: [this.selected[0].id]
        })
        .then(response => {
          let data = response.data;
          this.$store.commit("devices/loadDevicesStatus", data);
          // info
          let status = data[this.selected[0].id];
          if (status) {
            this.details.halo_data_links_info = status.halo_data_links_info;
            this.details.halo_system_report = status.halo_system_report;
          } else {
            this.details.halo_data_links_info = null;
            this.details.halo_system_report = null;
          }
          this.key = Math.random(); // force update component for reactivity
        })
        .catch(error => handleError(error))
        .then(this.sleeper(45000))
        .then(() => {
          this.fetchDevicesStatus();
        });
    },
    checkLocationStatus(latest_location) {
      if (latest_location.accuracy === 0) {
        if (
          latest_location.coordinate.reduce(
            (total, item) => (total += item),
            0
          ) === 0
        ) {
          return 0;
        }
        return 1;
      }
      return 2;
    },
    fetchDevicesState() {
      this.$store
        .dispatch("devices/fetchDevicesState")
        .catch(error => handleError(error));
    }
  }
};
</script>
